import React, { useEffect, useState } from "react";
import { Form, Select, notification, Row, Col } from "antd";
import {
  _get_all_state,
  _get_cities_by_state_code,
} from "../../common/axios_services";
import {
  showErrorNotification,
  showSuccessNotification,
} from "../../common/utils/notification";

const { Option } = Select;

const StateLgaSelects = ({
  form,
  initialPickupState,
  initialPickupLga,
  stateFieldName = "pickupState",
  lgaFieldName = "pickupLga",
  disabled = false,
  hide = false,
}) => {
  const [all_states, setAllStates] = useState([]);
  const [all_lgas, setAllLgas] = useState([]);

  const fetchCities = async (stateId = "", keyword = "") => {
    try {
      const uploadedCities = await _get_cities_by_state_code(stateId, keyword);
      setAllLgas(uploadedCities.data.data);
    } catch (err) {
      setAllLgas([]);
      if (err.response) {
        showErrorNotification(err?.response?.data?.message);
      } else {
        showErrorNotification(err.message);
      }
    }
  };

  const fetchAddedStates = async () => {
    try {
      const uploadedStates = await _get_all_state();
      setAllStates(uploadedStates.data.data);
    } catch (err) {
      setAllStates([]);
      if (err.response) {
        showErrorNotification(err?.response?.data?.message);
      } else {
        showErrorNotification(err.message);
      }
    }
  };

  useEffect(() => {
    fetchAddedStates();
  }, []);

  const currentState = Form.useWatch(stateFieldName, form);

  useEffect(() => {
    if (initialPickupState) {
      form.setFieldsValue({ [stateFieldName]: initialPickupState });
      const stateObj = all_states.find((s) => s.name === initialPickupState);
      if (stateObj) {
        fetchCities(stateObj.name);
      }
    }
    if (initialPickupLga) {
      form.setFieldsValue({ [lgaFieldName]: initialPickupLga });
    }
  }, [initialPickupState, initialPickupLga, all_states, stateFieldName, lgaFieldName, form]);

  useEffect(() => {
    if (currentState && all_states.length > 0) {
      const stateObj = all_states.find((s) => s.name === currentState || s.id === currentState);
      if (stateObj) {
        fetchCities(stateObj.name);
      }
    }
  }, [currentState, all_states]);

  const onChangeState = async (value, option) => {
    if (value) {
      form.setFieldsValue({ [lgaFieldName]: undefined });
      const stateId = option.value;
      await fetchCities(stateId);
    }
  };

  return (
    <div className={`grid grid-cols-2 ${hide ? "hidden" : ""}`}>
      <div>
        <Form.Item
          name={stateFieldName}
          label="State"
          rules={[
            {
              required: true,
              message: "Please select a state",
            },
          ]}
        >
          <Select
            placeholder="Select State"
            onChange={onChangeState}
            disabled={disabled}
          >
            {all_states.map((state) => (
              <Option key={state.id} value={state.name}>
                {state.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </div>
      <div>
        <Form.Item
          name={lgaFieldName}
          label="Location"
          rules={[
            {
              required: true,
              message: "Please select a Location",
            },
          ]}
        >
          <Select placeholder="Select Location" disabled={disabled}>
            {all_lgas.map((lga) => (
              <Option key={lga.id} value={lga.name}>
                {lga.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </div>
    </div>
  );
};

export default StateLgaSelects;
